import { render } from "./ChatsFinalizadosContent.vue?vue&type=template&id=3cb95b5f&ts=true"
import script from "./ChatsFinalizadosContent.vue?vue&type=script&lang=ts"
export * from "./ChatsFinalizadosContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__